'use-client';
import * as React from 'react';
import type {
  IDropDownMenuProps,
  IDropDownMenuImperativeActions,
} from '../../../DropDownMenu.types';
import DropDownMenuBase from '../../DropDownMenuBase';
import CirclesMenuButtonSkin from '../../../../MenuButton/viewer/skinComps/CirclesMenuButtonSkin/CirclesMenuButtonSkin';
import styles from './CirclesMenuSkin.scss';

const CirclesMenuSkin: React.ForwardRefRenderFunction<
  IDropDownMenuImperativeActions,
  IDropDownMenuProps
> = (props, ref) => {
  return (
    <DropDownMenuBase
      {...props}
      ref={ref}
      styles={styles}
      Button={CirclesMenuButtonSkin}
    />
  );
};

export default React.forwardRef(CirclesMenuSkin);
